import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { take } from 'rxjs/operators';
import { UrlService } from 'ticket-sdk';

@Injectable({
  providedIn: 'root'
})
export class UrlExtendedService {
  $privacyPolicyUrl: BehaviorSubject<string> = new BehaviorSubject<string>('');
  $termsUrl: BehaviorSubject<string> = new BehaviorSubject<string>('');
  $routeInfoUrl: BehaviorSubject<string> = new BehaviorSubject<string>('');

  constructor(private urlService: UrlService) {
    // Set default values
    this.$privacyPolicyUrl.next('https://www.trafikverket.se/resa-och-trafik/farjetrafik/ekeroleden#integritetspolicy');
    this.$termsUrl.next('https://www.trafikverket.se/resa-och-trafik/farjetrafik/ekeroleden#villkor');
    this.$routeInfoUrl.next('https://www.trafikverket.se/ekeroleden');

    // Fetch values from backend
    this.urlService.getUrls().pipe(take(1)).subscribe(urls => {
      for (const url of urls) {
        switch (url.name) {
          case 'PRIVACY_POLICY':
            this.$privacyPolicyUrl.next(url.value)
            break;
          case 'TERMS':
            this.$termsUrl.next(url.value)
            break;
          case 'ROUTE_INFO':
            this.$routeInfoUrl.next(url.value)
            break;
        }
      }
    });
  }
}
